/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AiRouteImport } from './routes/ai'
import { Route as ClaimRouteImport } from './routes/claim'
import { Route as JoinRouteImport } from './routes/join'
import { Route as LoginRouteImport } from './routes/login'
import { Route as NewRouteImport } from './routes/new'
import { Route as PlatformRouteImport } from './routes/platform'
import { Route as SigninRouteImport } from './routes/signin'
import { Route as AuthMagicRouteImport } from './routes/auth.magic'
import { Route as CatalogIndexRouteImport } from './routes/catalog.index'
import { Route as CatalogSlugRouteImport } from './routes/catalog.$slug'
import { Route as WWsRouteImport } from './routes/w.$ws'
import { Route as WWsIndexRouteImport } from './routes/w.$ws.index'
import { Route as WWsActivityRouteImport } from './routes/w.$ws.activity'
import { Route as WWsAdminRouteImport } from './routes/w.$ws.admin'
import { Route as WWsAgentopsRouteImport } from './routes/w.$ws.agentops'
import { Route as WWsBoardsRouteImport } from './routes/w.$ws.boards'
import { Route as WWsBooksRouteImport } from './routes/w.$ws.books'
import { Route as WWsCanvasRouteImport } from './routes/w.$ws.canvas'
import { Route as WWsDiagnosticsRouteImport } from './routes/w.$ws.diagnostics'
import { Route as WWsMapRouteImport } from './routes/w.$ws.map'
import { Route as WWsNeuralRouteImport } from './routes/w.$ws.neural'
import { Route as WWsRunsRouteImport } from './routes/w.$ws.runs'
import { Route as WWsSavedRouteImport } from './routes/w.$ws.saved'
import { Route as WWsSearchRouteImport } from './routes/w.$ws.search'
import { Route as WWsSettingsRouteImport } from './routes/w.$ws.settings'
import { Route as WWsSpendRouteImport } from './routes/w.$ws.spend'
import { Route as WWsWaitingRouteImport } from './routes/w.$ws.waiting'
import { Route as WWsCChannelRouteImport } from './routes/w.$ws.c.$channel'
import { Route as WWsDmChannelRouteImport } from './routes/w.$ws.dm.$channel'
import { Route as WWsNeuralApiRouteImport } from './routes/w.$ws.neural_.api'
import { Route as WWsCChannelReplayRouteImport } from './routes/w.$ws.c.$channel_.replay'
import { Route as WWsCChannelTRootRouteImport } from './routes/w.$ws.c.$channel.t.$root'
import { Route as WWsDmChannelTRootRouteImport } from './routes/w.$ws.dm.$channel.t.$root'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AiRoute = AiRouteImport.update({
  id: '/ai',
  path: '/ai',
  getParentRoute: () => rootRouteImport,
} as any)
const ClaimRoute = ClaimRouteImport.update({
  id: '/claim',
  path: '/claim',
  getParentRoute: () => rootRouteImport,
} as any)
const JoinRoute = JoinRouteImport.update({
  id: '/join',
  path: '/join',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const NewRoute = NewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => rootRouteImport,
} as any)
const PlatformRoute = PlatformRouteImport.update({
  id: '/platform',
  path: '/platform',
  getParentRoute: () => rootRouteImport,
} as any)
const SigninRoute = SigninRouteImport.update({
  id: '/signin',
  path: '/signin',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthMagicRoute = AuthMagicRouteImport.update({
  id: '/auth/magic',
  path: '/auth/magic',
  getParentRoute: () => rootRouteImport,
} as any)
const CatalogIndexRoute = CatalogIndexRouteImport.update({
  id: '/catalog/',
  path: '/catalog/',
  getParentRoute: () => rootRouteImport,
} as any)
const CatalogSlugRoute = CatalogSlugRouteImport.update({
  id: '/catalog/$slug',
  path: '/catalog/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const WWsRoute = WWsRouteImport.update({
  id: '/w/$ws',
  path: '/w/$ws',
  getParentRoute: () => rootRouteImport,
} as any)
const WWsIndexRoute = WWsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => WWsRoute,
} as any)
const WWsActivityRoute = WWsActivityRouteImport.update({
  id: '/activity',
  path: '/activity',
  getParentRoute: () => WWsRoute,
} as any)
const WWsAdminRoute = WWsAdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => WWsRoute,
} as any)
const WWsAgentopsRoute = WWsAgentopsRouteImport.update({
  id: '/agentops',
  path: '/agentops',
  getParentRoute: () => WWsRoute,
} as any)
const WWsBoardsRoute = WWsBoardsRouteImport.update({
  id: '/boards',
  path: '/boards',
  getParentRoute: () => WWsRoute,
} as any)
const WWsBooksRoute = WWsBooksRouteImport.update({
  id: '/books',
  path: '/books',
  getParentRoute: () => WWsRoute,
} as any)
const WWsCanvasRoute = WWsCanvasRouteImport.update({
  id: '/canvas',
  path: '/canvas',
  getParentRoute: () => WWsRoute,
} as any)
const WWsDiagnosticsRoute = WWsDiagnosticsRouteImport.update({
  id: '/diagnostics',
  path: '/diagnostics',
  getParentRoute: () => WWsRoute,
} as any)
const WWsMapRoute = WWsMapRouteImport.update({
  id: '/map',
  path: '/map',
  getParentRoute: () => WWsRoute,
} as any)
const WWsNeuralRoute = WWsNeuralRouteImport.update({
  id: '/neural',
  path: '/neural',
  getParentRoute: () => WWsRoute,
} as any)
const WWsRunsRoute = WWsRunsRouteImport.update({
  id: '/runs',
  path: '/runs',
  getParentRoute: () => WWsRoute,
} as any)
const WWsSavedRoute = WWsSavedRouteImport.update({
  id: '/saved',
  path: '/saved',
  getParentRoute: () => WWsRoute,
} as any)
const WWsSearchRoute = WWsSearchRouteImport.update({
  id: '/search',
  path: '/search',
  getParentRoute: () => WWsRoute,
} as any)
const WWsSettingsRoute = WWsSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => WWsRoute,
} as any)
const WWsSpendRoute = WWsSpendRouteImport.update({
  id: '/spend',
  path: '/spend',
  getParentRoute: () => WWsRoute,
} as any)
const WWsWaitingRoute = WWsWaitingRouteImport.update({
  id: '/waiting',
  path: '/waiting',
  getParentRoute: () => WWsRoute,
} as any)
const WWsCChannelRoute = WWsCChannelRouteImport.update({
  id: '/c/$channel',
  path: '/c/$channel',
  getParentRoute: () => WWsRoute,
} as any)
const WWsDmChannelRoute = WWsDmChannelRouteImport.update({
  id: '/dm/$channel',
  path: '/dm/$channel',
  getParentRoute: () => WWsRoute,
} as any)
const WWsNeuralApiRoute = WWsNeuralApiRouteImport.update({
  id: '/neural_/api',
  path: '/neural/api',
  getParentRoute: () => WWsRoute,
} as any)
const WWsCChannelReplayRoute = WWsCChannelReplayRouteImport.update({
  id: '/c/$channel_/replay',
  path: '/c/$channel/replay',
  getParentRoute: () => WWsRoute,
} as any)
const WWsCChannelTRootRoute = WWsCChannelTRootRouteImport.update({
  id: '/t/$root',
  path: '/t/$root',
  getParentRoute: () => WWsCChannelRoute,
} as any)
const WWsDmChannelTRootRoute = WWsDmChannelTRootRouteImport.update({
  id: '/t/$root',
  path: '/t/$root',
  getParentRoute: () => WWsDmChannelRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/ai': typeof AiRoute
  '/claim': typeof ClaimRoute
  '/join': typeof JoinRoute
  '/login': typeof LoginRoute
  '/new': typeof NewRoute
  '/platform': typeof PlatformRoute
  '/signin': typeof SigninRoute
  '/auth/magic': typeof AuthMagicRoute
  '/catalog/$slug': typeof CatalogSlugRoute
  '/w/$ws': typeof WWsRouteWithChildren
  '/catalog/': typeof CatalogIndexRoute
  '/w/$ws/activity': typeof WWsActivityRoute
  '/w/$ws/admin': typeof WWsAdminRoute
  '/w/$ws/agentops': typeof WWsAgentopsRoute
  '/w/$ws/boards': typeof WWsBoardsRoute
  '/w/$ws/books': typeof WWsBooksRoute
  '/w/$ws/canvas': typeof WWsCanvasRoute
  '/w/$ws/diagnostics': typeof WWsDiagnosticsRoute
  '/w/$ws/map': typeof WWsMapRoute
  '/w/$ws/neural': typeof WWsNeuralRoute
  '/w/$ws/runs': typeof WWsRunsRoute
  '/w/$ws/saved': typeof WWsSavedRoute
  '/w/$ws/search': typeof WWsSearchRoute
  '/w/$ws/settings': typeof WWsSettingsRoute
  '/w/$ws/spend': typeof WWsSpendRoute
  '/w/$ws/waiting': typeof WWsWaitingRoute
  '/w/$ws/': typeof WWsIndexRoute
  '/w/$ws/c/$channel': typeof WWsCChannelRouteWithChildren
  '/w/$ws/dm/$channel': typeof WWsDmChannelRouteWithChildren
  '/w/$ws/neural/api': typeof WWsNeuralApiRoute
  '/w/$ws/c/$channel/replay': typeof WWsCChannelReplayRoute
  '/w/$ws/c/$channel/t/$root': typeof WWsCChannelTRootRoute
  '/w/$ws/dm/$channel/t/$root': typeof WWsDmChannelTRootRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/ai': typeof AiRoute
  '/claim': typeof ClaimRoute
  '/join': typeof JoinRoute
  '/login': typeof LoginRoute
  '/new': typeof NewRoute
  '/platform': typeof PlatformRoute
  '/signin': typeof SigninRoute
  '/auth/magic': typeof AuthMagicRoute
  '/catalog/$slug': typeof CatalogSlugRoute
  '/catalog': typeof CatalogIndexRoute
  '/w/$ws/activity': typeof WWsActivityRoute
  '/w/$ws/admin': typeof WWsAdminRoute
  '/w/$ws/agentops': typeof WWsAgentopsRoute
  '/w/$ws/boards': typeof WWsBoardsRoute
  '/w/$ws/books': typeof WWsBooksRoute
  '/w/$ws/canvas': typeof WWsCanvasRoute
  '/w/$ws/diagnostics': typeof WWsDiagnosticsRoute
  '/w/$ws/map': typeof WWsMapRoute
  '/w/$ws/neural': typeof WWsNeuralRoute
  '/w/$ws/runs': typeof WWsRunsRoute
  '/w/$ws/saved': typeof WWsSavedRoute
  '/w/$ws/search': typeof WWsSearchRoute
  '/w/$ws/settings': typeof WWsSettingsRoute
  '/w/$ws/spend': typeof WWsSpendRoute
  '/w/$ws/waiting': typeof WWsWaitingRoute
  '/w/$ws': typeof WWsIndexRoute
  '/w/$ws/c/$channel': typeof WWsCChannelRouteWithChildren
  '/w/$ws/dm/$channel': typeof WWsDmChannelRouteWithChildren
  '/w/$ws/neural/api': typeof WWsNeuralApiRoute
  '/w/$ws/c/$channel/replay': typeof WWsCChannelReplayRoute
  '/w/$ws/c/$channel/t/$root': typeof WWsCChannelTRootRoute
  '/w/$ws/dm/$channel/t/$root': typeof WWsDmChannelTRootRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/ai': typeof AiRoute
  '/claim': typeof ClaimRoute
  '/join': typeof JoinRoute
  '/login': typeof LoginRoute
  '/new': typeof NewRoute
  '/platform': typeof PlatformRoute
  '/signin': typeof SigninRoute
  '/auth/magic': typeof AuthMagicRoute
  '/catalog/$slug': typeof CatalogSlugRoute
  '/w/$ws': typeof WWsRouteWithChildren
  '/catalog/': typeof CatalogIndexRoute
  '/w/$ws/activity': typeof WWsActivityRoute
  '/w/$ws/admin': typeof WWsAdminRoute
  '/w/$ws/agentops': typeof WWsAgentopsRoute
  '/w/$ws/boards': typeof WWsBoardsRoute
  '/w/$ws/books': typeof WWsBooksRoute
  '/w/$ws/canvas': typeof WWsCanvasRoute
  '/w/$ws/diagnostics': typeof WWsDiagnosticsRoute
  '/w/$ws/map': typeof WWsMapRoute
  '/w/$ws/neural': typeof WWsNeuralRoute
  '/w/$ws/runs': typeof WWsRunsRoute
  '/w/$ws/saved': typeof WWsSavedRoute
  '/w/$ws/search': typeof WWsSearchRoute
  '/w/$ws/settings': typeof WWsSettingsRoute
  '/w/$ws/spend': typeof WWsSpendRoute
  '/w/$ws/waiting': typeof WWsWaitingRoute
  '/w/$ws/': typeof WWsIndexRoute
  '/w/$ws/c/$channel': typeof WWsCChannelRouteWithChildren
  '/w/$ws/dm/$channel': typeof WWsDmChannelRouteWithChildren
  '/w/$ws/neural_/api': typeof WWsNeuralApiRoute
  '/w/$ws/c/$channel_/replay': typeof WWsCChannelReplayRoute
  '/w/$ws/c/$channel/t/$root': typeof WWsCChannelTRootRoute
  '/w/$ws/dm/$channel/t/$root': typeof WWsDmChannelTRootRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/ai'
    | '/claim'
    | '/join'
    | '/login'
    | '/new'
    | '/platform'
    | '/signin'
    | '/auth/magic'
    | '/catalog/$slug'
    | '/w/$ws'
    | '/catalog/'
    | '/w/$ws/activity'
    | '/w/$ws/admin'
    | '/w/$ws/agentops'
    | '/w/$ws/boards'
    | '/w/$ws/books'
    | '/w/$ws/canvas'
    | '/w/$ws/diagnostics'
    | '/w/$ws/map'
    | '/w/$ws/neural'
    | '/w/$ws/runs'
    | '/w/$ws/saved'
    | '/w/$ws/search'
    | '/w/$ws/settings'
    | '/w/$ws/spend'
    | '/w/$ws/waiting'
    | '/w/$ws/'
    | '/w/$ws/c/$channel'
    | '/w/$ws/dm/$channel'
    | '/w/$ws/neural/api'
    | '/w/$ws/c/$channel/replay'
    | '/w/$ws/c/$channel/t/$root'
    | '/w/$ws/dm/$channel/t/$root'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/ai'
    | '/claim'
    | '/join'
    | '/login'
    | '/new'
    | '/platform'
    | '/signin'
    | '/auth/magic'
    | '/catalog/$slug'
    | '/catalog'
    | '/w/$ws/activity'
    | '/w/$ws/admin'
    | '/w/$ws/agentops'
    | '/w/$ws/boards'
    | '/w/$ws/books'
    | '/w/$ws/canvas'
    | '/w/$ws/diagnostics'
    | '/w/$ws/map'
    | '/w/$ws/neural'
    | '/w/$ws/runs'
    | '/w/$ws/saved'
    | '/w/$ws/search'
    | '/w/$ws/settings'
    | '/w/$ws/spend'
    | '/w/$ws/waiting'
    | '/w/$ws'
    | '/w/$ws/c/$channel'
    | '/w/$ws/dm/$channel'
    | '/w/$ws/neural/api'
    | '/w/$ws/c/$channel/replay'
    | '/w/$ws/c/$channel/t/$root'
    | '/w/$ws/dm/$channel/t/$root'
  id:
    | '__root__'
    | '/'
    | '/ai'
    | '/claim'
    | '/join'
    | '/login'
    | '/new'
    | '/platform'
    | '/signin'
    | '/auth/magic'
    | '/catalog/$slug'
    | '/w/$ws'
    | '/catalog/'
    | '/w/$ws/activity'
    | '/w/$ws/admin'
    | '/w/$ws/agentops'
    | '/w/$ws/boards'
    | '/w/$ws/books'
    | '/w/$ws/canvas'
    | '/w/$ws/diagnostics'
    | '/w/$ws/map'
    | '/w/$ws/neural'
    | '/w/$ws/runs'
    | '/w/$ws/saved'
    | '/w/$ws/search'
    | '/w/$ws/settings'
    | '/w/$ws/spend'
    | '/w/$ws/waiting'
    | '/w/$ws/'
    | '/w/$ws/c/$channel'
    | '/w/$ws/dm/$channel'
    | '/w/$ws/neural_/api'
    | '/w/$ws/c/$channel_/replay'
    | '/w/$ws/c/$channel/t/$root'
    | '/w/$ws/dm/$channel/t/$root'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AiRoute: typeof AiRoute
  ClaimRoute: typeof ClaimRoute
  JoinRoute: typeof JoinRoute
  LoginRoute: typeof LoginRoute
  NewRoute: typeof NewRoute
  PlatformRoute: typeof PlatformRoute
  SigninRoute: typeof SigninRoute
  AuthMagicRoute: typeof AuthMagicRoute
  CatalogSlugRoute: typeof CatalogSlugRoute
  WWsRoute: typeof WWsRouteWithChildren
  CatalogIndexRoute: typeof CatalogIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ai': {
      id: '/ai'
      path: '/ai'
      fullPath: '/ai'
      preLoaderRoute: typeof AiRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/claim': {
      id: '/claim'
      path: '/claim'
      fullPath: '/claim'
      preLoaderRoute: typeof ClaimRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/join': {
      id: '/join'
      path: '/join'
      fullPath: '/join'
      preLoaderRoute: typeof JoinRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/new': {
      id: '/new'
      path: '/new'
      fullPath: '/new'
      preLoaderRoute: typeof NewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/platform': {
      id: '/platform'
      path: '/platform'
      fullPath: '/platform'
      preLoaderRoute: typeof PlatformRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signin': {
      id: '/signin'
      path: '/signin'
      fullPath: '/signin'
      preLoaderRoute: typeof SigninRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/magic': {
      id: '/auth/magic'
      path: '/auth/magic'
      fullPath: '/auth/magic'
      preLoaderRoute: typeof AuthMagicRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/catalog/': {
      id: '/catalog/'
      path: '/catalog'
      fullPath: '/catalog/'
      preLoaderRoute: typeof CatalogIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/catalog/$slug': {
      id: '/catalog/$slug'
      path: '/catalog/$slug'
      fullPath: '/catalog/$slug'
      preLoaderRoute: typeof CatalogSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/w/$ws': {
      id: '/w/$ws'
      path: '/w/$ws'
      fullPath: '/w/$ws'
      preLoaderRoute: typeof WWsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/w/$ws/': {
      id: '/w/$ws/'
      path: '/'
      fullPath: '/w/$ws/'
      preLoaderRoute: typeof WWsIndexRouteImport
      parentRoute: typeof WWsRoute
    }
    '/w/$ws/activity': {
      id: '/w/$ws/activity'
      path: '/activity'
      fullPath: '/w/$ws/activity'
      preLoaderRoute: typeof WWsActivityRouteImport
      parentRoute: typeof WWsRoute
    }
    '/w/$ws/admin': {
      id: '/w/$ws/admin'
      path: '/admin'
      fullPath: '/w/$ws/admin'
      preLoaderRoute: typeof WWsAdminRouteImport
      parentRoute: typeof WWsRoute
    }
    '/w/$ws/agentops': {
      id: '/w/$ws/agentops'
      path: '/agentops'
      fullPath: '/w/$ws/agentops'
      preLoaderRoute: typeof WWsAgentopsRouteImport
      parentRoute: typeof WWsRoute
    }
    '/w/$ws/boards': {
      id: '/w/$ws/boards'
      path: '/boards'
      fullPath: '/w/$ws/boards'
      preLoaderRoute: typeof WWsBoardsRouteImport
      parentRoute: typeof WWsRoute
    }
    '/w/$ws/books': {
      id: '/w/$ws/books'
      path: '/books'
      fullPath: '/w/$ws/books'
      preLoaderRoute: typeof WWsBooksRouteImport
      parentRoute: typeof WWsRoute
    }
    '/w/$ws/canvas': {
      id: '/w/$ws/canvas'
      path: '/canvas'
      fullPath: '/w/$ws/canvas'
      preLoaderRoute: typeof WWsCanvasRouteImport
      parentRoute: typeof WWsRoute
    }
    '/w/$ws/diagnostics': {
      id: '/w/$ws/diagnostics'
      path: '/diagnostics'
      fullPath: '/w/$ws/diagnostics'
      preLoaderRoute: typeof WWsDiagnosticsRouteImport
      parentRoute: typeof WWsRoute
    }
    '/w/$ws/map': {
      id: '/w/$ws/map'
      path: '/map'
      fullPath: '/w/$ws/map'
      preLoaderRoute: typeof WWsMapRouteImport
      parentRoute: typeof WWsRoute
    }
    '/w/$ws/neural': {
      id: '/w/$ws/neural'
      path: '/neural'
      fullPath: '/w/$ws/neural'
      preLoaderRoute: typeof WWsNeuralRouteImport
      parentRoute: typeof WWsRoute
    }
    '/w/$ws/runs': {
      id: '/w/$ws/runs'
      path: '/runs'
      fullPath: '/w/$ws/runs'
      preLoaderRoute: typeof WWsRunsRouteImport
      parentRoute: typeof WWsRoute
    }
    '/w/$ws/saved': {
      id: '/w/$ws/saved'
      path: '/saved'
      fullPath: '/w/$ws/saved'
      preLoaderRoute: typeof WWsSavedRouteImport
      parentRoute: typeof WWsRoute
    }
    '/w/$ws/search': {
      id: '/w/$ws/search'
      path: '/search'
      fullPath: '/w/$ws/search'
      preLoaderRoute: typeof WWsSearchRouteImport
      parentRoute: typeof WWsRoute
    }
    '/w/$ws/settings': {
      id: '/w/$ws/settings'
      path: '/settings'
      fullPath: '/w/$ws/settings'
      preLoaderRoute: typeof WWsSettingsRouteImport
      parentRoute: typeof WWsRoute
    }
    '/w/$ws/spend': {
      id: '/w/$ws/spend'
      path: '/spend'
      fullPath: '/w/$ws/spend'
      preLoaderRoute: typeof WWsSpendRouteImport
      parentRoute: typeof WWsRoute
    }
    '/w/$ws/waiting': {
      id: '/w/$ws/waiting'
      path: '/waiting'
      fullPath: '/w/$ws/waiting'
      preLoaderRoute: typeof WWsWaitingRouteImport
      parentRoute: typeof WWsRoute
    }
    '/w/$ws/c/$channel': {
      id: '/w/$ws/c/$channel'
      path: '/c/$channel'
      fullPath: '/w/$ws/c/$channel'
      preLoaderRoute: typeof WWsCChannelRouteImport
      parentRoute: typeof WWsRoute
    }
    '/w/$ws/dm/$channel': {
      id: '/w/$ws/dm/$channel'
      path: '/dm/$channel'
      fullPath: '/w/$ws/dm/$channel'
      preLoaderRoute: typeof WWsDmChannelRouteImport
      parentRoute: typeof WWsRoute
    }
    '/w/$ws/neural_/api': {
      id: '/w/$ws/neural_/api'
      path: '/neural/api'
      fullPath: '/w/$ws/neural/api'
      preLoaderRoute: typeof WWsNeuralApiRouteImport
      parentRoute: typeof WWsRoute
    }
    '/w/$ws/c/$channel_/replay': {
      id: '/w/$ws/c/$channel_/replay'
      path: '/c/$channel/replay'
      fullPath: '/w/$ws/c/$channel/replay'
      preLoaderRoute: typeof WWsCChannelReplayRouteImport
      parentRoute: typeof WWsRoute
    }
    '/w/$ws/c/$channel/t/$root': {
      id: '/w/$ws/c/$channel/t/$root'
      path: '/t/$root'
      fullPath: '/w/$ws/c/$channel/t/$root'
      preLoaderRoute: typeof WWsCChannelTRootRouteImport
      parentRoute: typeof WWsCChannelRoute
    }
    '/w/$ws/dm/$channel/t/$root': {
      id: '/w/$ws/dm/$channel/t/$root'
      path: '/t/$root'
      fullPath: '/w/$ws/dm/$channel/t/$root'
      preLoaderRoute: typeof WWsDmChannelTRootRouteImport
      parentRoute: typeof WWsDmChannelRoute
    }
  }
}

interface WWsCChannelRouteChildren {
  WWsCChannelTRootRoute: typeof WWsCChannelTRootRoute
}

const WWsCChannelRouteChildren: WWsCChannelRouteChildren = {
  WWsCChannelTRootRoute: WWsCChannelTRootRoute,
}

const WWsCChannelRouteWithChildren = WWsCChannelRoute._addFileChildren(
  WWsCChannelRouteChildren,
)

interface WWsDmChannelRouteChildren {
  WWsDmChannelTRootRoute: typeof WWsDmChannelTRootRoute
}

const WWsDmChannelRouteChildren: WWsDmChannelRouteChildren = {
  WWsDmChannelTRootRoute: WWsDmChannelTRootRoute,
}

const WWsDmChannelRouteWithChildren = WWsDmChannelRoute._addFileChildren(
  WWsDmChannelRouteChildren,
)

interface WWsRouteChildren {
  WWsActivityRoute: typeof WWsActivityRoute
  WWsAdminRoute: typeof WWsAdminRoute
  WWsAgentopsRoute: typeof WWsAgentopsRoute
  WWsBoardsRoute: typeof WWsBoardsRoute
  WWsBooksRoute: typeof WWsBooksRoute
  WWsCanvasRoute: typeof WWsCanvasRoute
  WWsDiagnosticsRoute: typeof WWsDiagnosticsRoute
  WWsMapRoute: typeof WWsMapRoute
  WWsNeuralRoute: typeof WWsNeuralRoute
  WWsRunsRoute: typeof WWsRunsRoute
  WWsSavedRoute: typeof WWsSavedRoute
  WWsSearchRoute: typeof WWsSearchRoute
  WWsSettingsRoute: typeof WWsSettingsRoute
  WWsSpendRoute: typeof WWsSpendRoute
  WWsWaitingRoute: typeof WWsWaitingRoute
  WWsIndexRoute: typeof WWsIndexRoute
  WWsCChannelRoute: typeof WWsCChannelRouteWithChildren
  WWsDmChannelRoute: typeof WWsDmChannelRouteWithChildren
  WWsNeuralApiRoute: typeof WWsNeuralApiRoute
  WWsCChannelReplayRoute: typeof WWsCChannelReplayRoute
}

const WWsRouteChildren: WWsRouteChildren = {
  WWsActivityRoute: WWsActivityRoute,
  WWsAdminRoute: WWsAdminRoute,
  WWsAgentopsRoute: WWsAgentopsRoute,
  WWsBoardsRoute: WWsBoardsRoute,
  WWsBooksRoute: WWsBooksRoute,
  WWsCanvasRoute: WWsCanvasRoute,
  WWsDiagnosticsRoute: WWsDiagnosticsRoute,
  WWsMapRoute: WWsMapRoute,
  WWsNeuralRoute: WWsNeuralRoute,
  WWsRunsRoute: WWsRunsRoute,
  WWsSavedRoute: WWsSavedRoute,
  WWsSearchRoute: WWsSearchRoute,
  WWsSettingsRoute: WWsSettingsRoute,
  WWsSpendRoute: WWsSpendRoute,
  WWsWaitingRoute: WWsWaitingRoute,
  WWsIndexRoute: WWsIndexRoute,
  WWsCChannelRoute: WWsCChannelRouteWithChildren,
  WWsDmChannelRoute: WWsDmChannelRouteWithChildren,
  WWsNeuralApiRoute: WWsNeuralApiRoute,
  WWsCChannelReplayRoute: WWsCChannelReplayRoute,
}

const WWsRouteWithChildren = WWsRoute._addFileChildren(WWsRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AiRoute: AiRoute,
  ClaimRoute: ClaimRoute,
  JoinRoute: JoinRoute,
  LoginRoute: LoginRoute,
  NewRoute: NewRoute,
  PlatformRoute: PlatformRoute,
  SigninRoute: SigninRoute,
  AuthMagicRoute: AuthMagicRoute,
  CatalogSlugRoute: CatalogSlugRoute,
  WWsRoute: WWsRouteWithChildren,
  CatalogIndexRoute: CatalogIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
